(function () {
  "use strict";

  UninviteTraineesCtrl.$inject = ['$scope', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('UninviteTraineesCtrl', UninviteTraineesCtrl);

  function UninviteTraineesCtrl($scope, $timeout) {

    $scope.modal = {
      content: 0,
      data: {},
      status: ''
    };

    $scope.uninviteTrainees = function () {
      $scope.modal.status = 'saving';
      $scope.$emit('uninviteTraineesConfirmEvent', $scope.modal.data, function () {
        $scope.dismiss();
        $timeout(function () {
          $scope.modal.status = ''
        }, 500);
      });
    };

    $scope.$on('traineesToDropEvent', function (event, numberOfTrainees) {
      $scope.modal.status = '';
      $scope.modal.data = {};
      $scope.modal.content = numberOfTrainees;
    });

    $scope.$on('uninviteTraineeEvent', function (event, trainee) {
      if (!trainee) return;
      $scope.modal.content = 1;
      $scope.modal.data = trainee;
      $scope.show();
    });
  }

})();
